import { API_CALL } from '../../../../middleware/api';

export const GET_DEVICE_INVOICES_INITIAL = 'get-device-invoices-initial';
export const GET_DEVICE_INVOICES_INITIAL_RESULT = `${GET_DEVICE_INVOICES_INITIAL}/result`;
export const GET_DEVICE_INVOICES_INITIAL_ERROR = `${GET_DEVICE_INVOICES_INITIAL}/error`;

export const GET_DEVICE_INVOICES_RECURRING = 'get-device-invoices-recurring';
export const GET_DEVICE_INVOICES_RECURRING_RESULT = `${GET_DEVICE_INVOICES_RECURRING}/result`;
export const GET_DEVICE_INVOICES_RECURRING_ERROR = `${GET_DEVICE_INVOICES_RECURRING}/error`;

export const GET_DEVICE_INVOICE_INITIAL_DETAILS = 'get-device-invoice-initial-details';
export const GET_DEVICE_INVOICE_INITIAL_DETAILS_RESULT = `${GET_DEVICE_INVOICE_INITIAL_DETAILS}/result`;
export const GET_DEVICE_INVOICE_INITIAL_DETAILS_ERROR = `${GET_DEVICE_INVOICE_INITIAL_DETAILS}/error`;

export const GET_DEVICE_INVOICE_RECURRING_DETAILS = 'get-device-invoice-recurring-details';
export const GET_DEVICE_INVOICE_RECURRING_DETAILS_RESULT = `${GET_DEVICE_INVOICE_RECURRING_DETAILS}/result`;
export const GET_DEVICE_INVOICE_RECURRING_DETAILS_ERROR = `${GET_DEVICE_INVOICE_RECURRING_DETAILS}/error`;

export const GENERATE_DEVICE_INVOICE_RECURRING = 'generate-device-invoice-recurring';
export const GENERATE_DEVICE_INVOICE_RECURRING_RESULT = `${GENERATE_DEVICE_INVOICE_RECURRING}/result`;
export const GENERATE_DEVICE_INVOICE_RECURRING_ERROR = `${GENERATE_DEVICE_INVOICE_RECURRING}/error`;

export const RECALCULATE_DEVICE_INVOICE_INITIAL = 'recalculate-device-invoice-initial';
export const RECALCULATE_DEVICE_INVOICE_INITIAL_RESULT = `${RECALCULATE_DEVICE_INVOICE_INITIAL}/result`;
export const RECALCULATE_DEVICE_INVOICE_INITIAL_ERROR = `${RECALCULATE_DEVICE_INVOICE_INITIAL}/error`;

export const RECALCULATE_DEVICE_INVOICE_RECURRING = 'recalculate-device-invoice-recurring';
export const RECALCULATE_DEVICE_INVOICE_RECURRING_RESULT = `${RECALCULATE_DEVICE_INVOICE_RECURRING}/result`;
export const RECALCULATE_DEVICE_INVOICE_RECURRING_ERROR = `${RECALCULATE_DEVICE_INVOICE_RECURRING}/error`;

export const CHANGE_DEVICE_INVOICE_INITIAL_STATUS = 'change-device-invoice-initial-status';
export const CHANGE_DEVICE_INVOICE_INITIAL_STATUS_RESULT = `${CHANGE_DEVICE_INVOICE_INITIAL_STATUS}/result`;
export const CHANGE_DEVICE_INVOICE_INITIAL_STATUS_ERROR = `${CHANGE_DEVICE_INVOICE_INITIAL_STATUS}/error`;

export const CHANGE_DEVICE_INVOICE_RECURRING_STATUS = 'change-device-invoice-recurring-status';
export const CHANGE_DEVICE_INVOICE_RECURRING_STATUS_RESULT = `${CHANGE_DEVICE_INVOICE_RECURRING_STATUS}/result`;
export const CHANGE_DEVICE_INVOICE_RECURRING_STATUS_ERROR = `${CHANGE_DEVICE_INVOICE_RECURRING_STATUS}/error`;

export const RESTORE_DEVICE_INVOICE_INITIAL = 'restore-device-invoice-initial';
export const RESTORE_DEVICE_INVOICE_INITIAL_RESULT = `${RESTORE_DEVICE_INVOICE_INITIAL}/result`;
export const RESTORE_DEVICE_INVOICE_INITIAL_ERROR = `${RESTORE_DEVICE_INVOICE_INITIAL}/error`;

export const RESTORE_DEVICE_INVOICE_RECURRING = 'restore-device-invoice-recurring';
export const RESTORE_DEVICE_INVOICE_RECURRING_RESULT = `${RESTORE_DEVICE_INVOICE_RECURRING}/result`;
export const RESTORE_DEVICE_INVOICE_RECURRING_ERROR = `${RESTORE_DEVICE_INVOICE_RECURRING}/error`;

export const SET_DEVICE_INVOICE_DATE = 'set-device-invoice-date';
export const SET_DEVICE_INVOICE_DATE_RESULT = `${SET_DEVICE_INVOICE_DATE}/result`;
export const SET_DEVICE_INVOICE_DATE_ERROR = `${SET_DEVICE_INVOICE_DATE}/error`;

export const CLEAR_DEVICE_INVOICE_DATE = 'clear-device-invoice-date';
export const CLEAR_DEVICE_INVOICE_DATE_RESULT = `${CLEAR_DEVICE_INVOICE_DATE}/result`;
export const CLEAR_DEVICE_INVOICE_DATE_ERROR = `${CLEAR_DEVICE_INVOICE_DATE}/error`;

export const COMMENT_DEVICE_INVOICE_INITIAL = 'comment-device-invoice-initial';
export const COMMENT_DEVICE_INVOICE_INITIAL_RESULT = `${COMMENT_DEVICE_INVOICE_INITIAL}/result`;
export const COMMENT_DEVICE_INVOICE_INITIAL_ERROR = `${COMMENT_DEVICE_INVOICE_INITIAL}/error`;

export const COMMENT_DEVICE_INVOICE_RECURRING = 'comment-device-invoice-recurring';
export const COMMENT_DEVICE_INVOICE_RECURRING_RESULT = `${COMMENT_DEVICE_INVOICE_RECURRING}/result`;
export const COMMENT_DEVICE_INVOICE_RECURRING_ERROR = `${COMMENT_DEVICE_INVOICE_RECURRING}/error`;

export const UPDATE_DEVICE_INVOICE_INITIAL = 'update-device-invoice-initial';
export const UPDATE_DEVICE_INVOICE_INITIAL_RESULT = `${UPDATE_DEVICE_INVOICE_INITIAL}/result`;
export const UPDATE_DEVICE_INVOICE_INITIAL_ERROR = `${UPDATE_DEVICE_INVOICE_INITIAL}/error`;

export const UPDATE_DEVICE_INVOICE_RECURRING = 'update-device-invoice-recurring';
export const UPDATE_DEVICE_INVOICE_RECURRING_RESULT = `${UPDATE_DEVICE_INVOICE_RECURRING}/result`;
export const UPDATE_DEVICE_INVOICE_RECURRING_ERROR = `${UPDATE_DEVICE_INVOICE_RECURRING}/error`;

export const GET_DEVICE_INVOICE_INITIAL_HISTORY = 'get-device-invoice-initial-history';
export const GET_DEVICE_INVOICE_INITIAL_HISTORY_RESULT = `${GET_DEVICE_INVOICE_INITIAL_HISTORY}/result`;
export const GET_DEVICE_INVOICE_INITIAL_HISTORY_ERROR = `${GET_DEVICE_INVOICE_INITIAL_HISTORY}/error`;

export const GET_DEVICE_INVOICE_RECURRING_HISTORY = 'get-device-invoice-recurring-history';
export const GET_DEVICE_INVOICE_RECURRING_HISTORY_RESULT = `${GET_DEVICE_INVOICE_RECURRING_HISTORY}/result`;
export const GET_DEVICE_INVOICE_RECURRING_HISTORY_ERROR = `${GET_DEVICE_INVOICE_RECURRING_HISTORY}/error`;

export const UPDATE_DEVICE_INVOICE_INITIAL_COMMENT = 'update-device-invoice-initial-comment';
export const UPDATE_DEVICE_INVOICE_INITIAL_COMMENT_RESULT = `${UPDATE_DEVICE_INVOICE_INITIAL_COMMENT}/result`;
export const UPDATE_DEVICE_INVOICE_INITIAL_COMMENT_ERROR = `${UPDATE_DEVICE_INVOICE_INITIAL_COMMENT}/error`;

export const UPDATE_DEVICE_INVOICE_RECURRING_COMMENT = 'update-device-invoice-recurring-comment';
export const UPDATE_DEVICE_INVOICE_RECURRING_COMMENT_RESULT = `${UPDATE_DEVICE_INVOICE_RECURRING_COMMENT}/result`;
export const UPDATE_DEVICE_INVOICE_RECURRING_COMMENT_ERROR = `${UPDATE_DEVICE_INVOICE_RECURRING_COMMENT}/error`;

export const DELETE_DEVICE_INVOICE_INITIAL_COMMENT = 'delete-device-invoice-initial-comment';
export const DELETE_DEVICE_INVOICE_INITIAL_COMMENT_RESULT = `${DELETE_DEVICE_INVOICE_INITIAL_COMMENT}/result`;
export const DELETE_DEVICE_INVOICE_INITIAL_COMMENT_ERROR = `${DELETE_DEVICE_INVOICE_INITIAL_COMMENT}/error`;

export const DELETE_DEVICE_INVOICE_RECURRING_COMMENT = 'delete-device-invoice-recurring-comment';
export const DELETE_DEVICE_INVOICE_RECURRING_COMMENT_RESULT = `${DELETE_DEVICE_INVOICE_RECURRING_COMMENT}/result`;
export const DELETE_DEVICE_INVOICE_RECURRING_COMMENT_ERROR = `${DELETE_DEVICE_INVOICE_RECURRING_COMMENT}/error`;

export const DOWNLOAD_DEVICE_INVOICE_INITIAL = 'download-device-invoice-initial';
export const DOWNLOAD_DEVICE_INVOICE_INITIAL_RESULT = `${DOWNLOAD_DEVICE_INVOICE_INITIAL}/result`;
export const DOWNLOAD_DEVICE_INVOICE_INITIAL_ERROR = `${DOWNLOAD_DEVICE_INVOICE_INITIAL}/error`;

export const DOWNLOAD_DEVICE_INVOICE_RECURRING = 'download-device-invoice-recurring';
export const DOWNLOAD_DEVICE_INVOICE_RECURRING_RESULT = `${DOWNLOAD_DEVICE_INVOICE_RECURRING}/result`;
export const DOWNLOAD_DEVICE_INVOICE_RECURRING_ERROR = `${DOWNLOAD_DEVICE_INVOICE_RECURRING}/error`;

export const GET_DEVICE_INVOICE_PRICING_ROWS = 'get-device-invoice-pricing-rows';
export const GET_DEVICE_INVOICE_PRICING_ROWS_RESULT = `${GET_DEVICE_INVOICE_PRICING_ROWS}/result`;
export const GET_DEVICE_INVOICE_PRICING_ROWS_ERROR = `${GET_DEVICE_INVOICE_PRICING_ROWS}/error`;

export const GET_DEVICE_INVOICE_PRICING_FORM_BUNDLE = 'get-device-invoice-pricing-form-bundle';
export const GET_DEVICE_INVOICE_PRICING_FORM_BUNDLE_RESULT = `${GET_DEVICE_INVOICE_PRICING_FORM_BUNDLE}/result`;
export const GET_DEVICE_INVOICE_PRICING_FORM_BUNDLE_ERROR = `${GET_DEVICE_INVOICE_PRICING_FORM_BUNDLE}/error`;

export const CREATE_DEVICE_INVOICE_PRICING = 'create-device-invoice-pricing';
export const CREATE_DEVICE_INVOICE_PRICING_RESULT = `${CREATE_DEVICE_INVOICE_PRICING}/result`;
export const CREATE_DEVICE_INVOICE_PRICING_ERROR = `${CREATE_DEVICE_INVOICE_PRICING}/error`;

export const UPDATE_DEVICE_INVOICE_PRICING = 'update-device-invoice-pricing';
export const UPDATE_DEVICE_INVOICE_PRICING_RESULT = `${UPDATE_DEVICE_INVOICE_PRICING}/result`;
export const UPDATE_DEVICE_INVOICE_PRICING_ERROR = `${UPDATE_DEVICE_INVOICE_PRICING}/error`;

export const DELETE_DEVICE_INVOICE_PRICING = 'delete-device-invoice-pricing';
export const DELETE_DEVICE_INVOICE_PRICING_RESULT = `${DELETE_DEVICE_INVOICE_PRICING}/result`;
export const DELETE_DEVICE_INVOICE_PRICING_ERROR = `${DELETE_DEVICE_INVOICE_PRICING}/error`;

export const invoiceActions = {
  getDeviceInvoicesInitial: params => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/initial',
      method: 'GET',
      params,
    },
    type: GET_DEVICE_INVOICES_INITIAL,
  }),
  getDeviceInvoicesRecurring: params => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/recurring',
      method: 'GET',
      params,
    },
    type: GET_DEVICE_INVOICES_RECURRING,
  }),
  getDeviceInvoiceInitialDetails: id => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/initial/${id}`,
      method: 'GET',
    },
    type: GET_DEVICE_INVOICE_INITIAL_DETAILS,
  }),
  getDeviceInvoiceRecurringDetails: id => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/recurring/${id}`,
      method: 'GET',
    },
    type: GET_DEVICE_INVOICE_RECURRING_DETAILS,
  }),
  generateDeviceInvoiceRecurring: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/recurring/generate',
      method: 'POST',
      data,
    },
    type: GENERATE_DEVICE_INVOICE_RECURRING,
  }),
  recalculateDeviceInvoiceInitial: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/initial/recalculate',
      method: 'POST',
      data,
    },
    type: RECALCULATE_DEVICE_INVOICE_INITIAL,
  }),
  recalculateDeviceInvoiceRecurring: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/recurring/recalculate',
      method: 'POST',
      data,
    },
    type: RECALCULATE_DEVICE_INVOICE_RECURRING,
  }),
  changeDeviceInvoiceInitialStatus: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/initial/change-status',
      method: 'POST',
      data,
    },
    type: CHANGE_DEVICE_INVOICE_INITIAL_STATUS,
  }),
  changeDeviceInvoiceRecurringStatus: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/recurring/change-status',
      method: 'POST',
      data,
    },
    type: CHANGE_DEVICE_INVOICE_RECURRING_STATUS,
  }),
  restoreDeviceInvoiceInitial: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/initial/restore',
      method: 'POST',
      data,
    },
    type: RESTORE_DEVICE_INVOICE_INITIAL,
  }),
  restoreDeviceInvoiceRecurring: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/recurring/restore',
      method: 'POST',
      data,
    },
    type: RESTORE_DEVICE_INVOICE_RECURRING,
  }),
  setDeviceInvoiceDate: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/set-invoice-date',
      method: 'POST',
      data,
    },
    type: SET_DEVICE_INVOICE_DATE,
  }),
  clearDeviceInvoiceDate: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/clear-invoice-date',
      method: 'POST',
      data,
    },
    type: CLEAR_DEVICE_INVOICE_DATE,
  }),
  commentDeviceInvoiceInitial: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/initial/comment',
      method: 'POST',
      data,
    },
    type: COMMENT_DEVICE_INVOICE_INITIAL,
  }),
  commentDeviceInvoiceRecurring: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/recurring/comment',
      method: 'POST',
      data,
    },
    type: COMMENT_DEVICE_INVOICE_RECURRING,
  }),
  updateDeviceInvoiceInitial: (invoiceUuid, data) => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/initial/${invoiceUuid}`,
      method: 'PUT',
      data,
    },
    type: UPDATE_DEVICE_INVOICE_INITIAL,
  }),
  updateDeviceInvoiceRecurring: (invoiceUuid, data) => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/recurring/${invoiceUuid}`,
      method: 'PUT',
      data,
    },
    type: UPDATE_DEVICE_INVOICE_RECURRING,
  }),
  getDeviceInvoiceInitialHistory: invoiceUuid => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/initial/${invoiceUuid}/history`,
      method: 'GET',
    },
    type: GET_DEVICE_INVOICE_INITIAL_HISTORY,
  }),
  getDeviceInvoiceRecurringHistory: invoiceUuid => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/recurring/${invoiceUuid}/history`,
      method: 'GET',
    },
    type: GET_DEVICE_INVOICE_RECURRING_HISTORY,
  }),
  updateDeviceInvoiceInitialComment: (invoiceUuid, historyId, data) => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/initial/${invoiceUuid}/history/${historyId}`,
      method: 'PUT',
      data,
    },
    type: UPDATE_DEVICE_INVOICE_INITIAL_COMMENT,
  }),
  updateDeviceInvoiceRecurringComment: (invoiceUuid, historyId, data) => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/recurring/${invoiceUuid}/history/${historyId}`,
      method: 'PUT',
      data,
    },
    type: UPDATE_DEVICE_INVOICE_RECURRING_COMMENT,
  }),
  deleteDeviceInvoiceInitialComment: (invoiceUuid, historyId) => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/initial/${invoiceUuid}/history/${historyId}`,
      method: 'DELETE',
    },
    type: DELETE_DEVICE_INVOICE_INITIAL_COMMENT,
  }),
  deleteDeviceInvoiceRecurringComment: (invoiceUuid, historyId) => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/recurring/${invoiceUuid}/history/${historyId}`,
      method: 'DELETE',
    },
    type: DELETE_DEVICE_INVOICE_RECURRING_COMMENT,
  }),
  downloadDeviceInvoiceInitial: params => ({
    [API_CALL]: {
      endpoint: 'portal/billing/report/devices/initial',
      method: 'GET',
      params,
      responseType: 'blob',
    },
    type: DOWNLOAD_DEVICE_INVOICE_INITIAL,
  }),
  downloadDeviceInvoiceRecurring: params => ({
    [API_CALL]: {
      endpoint: 'portal/billing/report/devices/recurring',
      method: 'GET',
      params,
      responseType: 'blob',
    },
    type: DOWNLOAD_DEVICE_INVOICE_RECURRING,
  }),
  getDeviceInvoicePricingRows: params => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/pricing',
      method: 'GET',
      params,
    },
    type: GET_DEVICE_INVOICE_PRICING_ROWS,
  }),
  getDeviceInvoicePricingFormBundle: () => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/pricing/form-bundle',
      method: 'GET',
    },
    type: GET_DEVICE_INVOICE_PRICING_FORM_BUNDLE,
  }),
  createDeviceInvoicePricing: data => ({
    [API_CALL]: {
      endpoint: 'portal/billing/invoices/pricing',
      method: 'POST',
      data,
    },
    type: CREATE_DEVICE_INVOICE_PRICING,
  }),
  updateDeviceInvoicePricing: (pricingId, data) => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/pricing/${pricingId}`,
      method: 'PUT',
      data,
    },
    type: UPDATE_DEVICE_INVOICE_PRICING,
  }),
  deleteDeviceInvoicePricing: pricingId => ({
    [API_CALL]: {
      endpoint: `portal/billing/invoices/pricing/${pricingId}`,
      method: 'DELETE',
    },
    type: DELETE_DEVICE_INVOICE_PRICING,
  }),
};
